const TYPENAMES = {
  articleHeader: 'ArticleHeader',
  articleHeaderImage: 'ArticleHeaderImage',
  articleOverview: 'ArticleOverview',
  articleViewed: 'ArticleViewed',
  assetCollection: 'AssetCollection',
  audioEmbed: 'AudioEmbed',
  brandHeader: 'BrandHeader',
  brandTitleBar: 'BrandTitleBar',
  onboardingInformationLink: 'OnboardingInformationLink',
  button: 'Button',
  cardList: 'CardList',
  cardOverview: 'CardOverview',
  catalogNavigation: 'CatalogNavigation',
  catalogOverview: 'CatalogOverview',
  comments: 'Comments',
  donationForm: 'DonationForm',
  download: 'Download',
  facebookEmbed: 'FacebookEmbed',
  footer: 'Footer',
  form: 'Form',
  heading: 'Heading',
  imageAndText: 'ImageAndText',
  instagramEmbed: 'InstagramEmbed',
  likeButton: 'LikeButton',
  mediaHeader: 'MediaHeader',
  mediaOverview: 'MediaOverview',
  mediaViewed: 'MediaViewed',
  mixedContentSlider: 'MixedContentSlider',
  newsletterSubscription: 'NewsletterSubscription',
  onboardingBanner: 'OnboardingBanner',
  photo: 'Photo',
  playerEmbed: 'PlayerEmbed',
  popularRecommendationList: 'PopularRecommendationList',
  popularByBrandRecommendationList: 'PopularByBrandRecommendationList',
  propositionList: 'PropositionList',
  qualifioEmbed: 'QualifioEmbed',
  quote: 'Quote',
  recommendationList: 'RecommendationList',
  scrollIntoView: 'ScrollIntoView',
  socialFooter: 'SocialFooter',
  spacer: 'Spacer',
  spotifyEmbed: 'SpotifyEmbed',
  tagOrCategoryItems: 'TagOrCategoryItems',
  standalonePageHeader: 'StandalonePageHeader',
  profileHeader: 'ProfileHeader',
  sterBanner: 'SterBanner',
  subNavigation: 'SubNavigation',
  tagList: 'TagList',
  teaser: 'BrandTeaser',
  text: 'Text',
  theaterPlayerEmbed: 'TheaterPlayerEmbed',
  topBar: 'TopBar',
  tweetEmbed: 'TweetEmbed',
  urlReference: 'UrlReference',
  youtubeEmbed: 'YoutubeEmbed',
  brandNavigation: 'Brandnavigation',
  profile: 'Profile',
};

export default TYPENAMES;
